import { ClickType, GA4EventName, GA4FeatureCategory, trackAnalyticsEvent } from '@jsmdg/tracking';

async function trackThumbnailClicked(url: string): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'Select',
        label: 'PicturePreview',
        eventData: {
            eventName: GA4EventName.SwitchPicture,
            feature_category: GA4FeatureCategory.ProductdetailGallery,
            click_type: ClickType.Select,
            click_url: url,
        },
    });
}

async function trackImageSlide(label: string, url: string): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'Slide',
        label,
        eventData: {
            eventName: GA4EventName.SwitchPicture,
            feature_category: GA4FeatureCategory.ProductdetailGallery,
            click_type: label,
            click_url: url,
        },
    });
}

export { trackImageSlide, trackThumbnailClicked };
